import * as yup from "yup";
import { DocumentoSchema } from "./DocumentoSchema";
import { ArchivoSchema } from "./ArchivoSchema";

export const DocumentoAdjuntoSchema = yup.object().shape({
  documento: DocumentoSchema.required(
    "errors.documentoAdjunto.documento.required",
  ),
  archivo: ArchivoSchema.required("errors.documentoAdjunto.archivo.required"),
});
